<template>
  <div class="page container">

    <!-- <div class="row">
      <div class="col-12 text-left">
        <router-link class='btn btn-primary' to="/admin/produtos/0">Adicionar Produto</router-link>
      </div>
    </div> -->


    <div class="row mt-5"  >
      <div class="col text-left">

         <h3> <b>Abertura da Lista</b> </h3>
         <hr />

      <form class='text-left mt-5' ref="contato">


            <!-- listainfo: <pre>{{mylistaInfo}}</pre>
            listainfoState: <pre>{{$store.getters.listaInfo}}</pre> -->

              <div class="row mt-5" v-if='error!=""' >
      <div class="col">
           <div class="alert alert-danger" v-html="error">
            
        </div>
    
      </div>
    </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">*Data Abertura </label>
                  <div class="col-sm-8">
                  <input v-model="mylistaInfo.dataInicial" type="date" class="form-control d-inline-block col-6" required  >
                 às  <input v-model="mylistaInfo.horarioInicial" type="time" class="form-control d-inline-block  col-5" required  >
                </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-4 col-form-label " >*Data Fechamento </label>
                  <div class="col-sm-8">
            <input v-model="mylistaInfo.dataFinal" type="date" class="form-control d-inline-block col-6" required  >
                 as <input v-model="mylistaInfo.horarioFinal" type="time" class="form-control d-inline-block  col-5" required  >
                </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-4 col-form-label " >Texto para exibir quando a lista estiver fechada </label>
                  <div class="col-sm-8">
                  <textarea v-model="mylistaInfo.info"  class="form-control"></textarea>
                  <!-- <input v-model="mylistaInfo.info" type="text" class="form-control d-inline-block col-6" required  > -->
           
                </div>
            </div>




          </form>

          <button class='btn btn-primary' @click="updateListInfo">  
            <span v-if="saving==false">Salvar</span>
            <span v-if="saving==true">Salvando.....</span>
          </button>

      </div>
    </div>
 
<div class="row mt-5 pt-5"  >
    <div class="col text-left">

        <h3> <b>Produtos</b>     <button class='btn btn-primary pull-right' style="float:right" @click="limparEstoque" > Zerar todo o Estoque </button> </h3>
        <!-- <hr/> -->

        <selecionar-produto-edit  
            v-for="produto in produtos" 
            :key="'produto'+produto.id"
            :produto="produto" 
       />

    </div>

</div>

 <div class="row mt-3 mb-5">
      <div class="col-12 text-left">
        <router-link class='btn btn-primary' to="/"> Ir para página inicial </router-link>
      </div>
    </div>




       
       

  </div>
</template>

<script>

import SelecionarProdutoEdit from '@/components/produtos/selecionar-produto-edit'
// import QuantidadeSelector from '@/components/elementos/quantidade-selector'

export default {
        components:{
            // QuantidadeSelector,
            SelecionarProdutoEdit
        },

        

  data(){
    return {
      error:'',
      saving:false,
      enviado:false,
      mylistaInfo: 
      {
         dataInicial:'2020-04-21', 
         dataFinal:'',
         id:'lista',
     },
    }
  },

  created:function(){
     this.mylistaInfo = this.listaInfo
  },

  computed:{

      listaInfo:function(){
          return {...this.$store.getters.listaInfo}
      },

      listaProdutos:function(){
          return this.$store.getters.lista
      },
      produtos:function(){
          return this.$store.getters.produtos
      },

  },

  watch:{
    listaInfo:function(){
        this.mylistaInfo = this.listaInfo 
    }
    
  },


  methods:{
    limparEstoque:async function(){
        this.$store.dispatch('limpaEstoque') 
    },

    updateListInfo:async function(){
      this.saving = true
        let res = await this.$store.dispatch('listaInfo',this.mylistaInfo)
        if(res==false){
          this.error = "ocorreu um erro ao salvar a lista"
        }
         this.saving = false
    }
  }

}
</script>
